import { render } from "./full-sidebar.vue?vue&type=template&id=0c808c70"
import script from "./full-sidebar.vue?vue&type=script&lang=js"
export * from "./full-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__